/**
 * ## reslimit controller
 *
 * @module src/controllers/reslimit
 */

"use strict";

const component = require("../../components/component");
const modal = require("../../components/modal");
const notification = require("../../components/notification");
const reslimit = require("../../components/reslimit");
const moment = require("moment-timezone");
const l = require("../../common").localization;

let limitID = null;
let limitName = null;
let limitData = null;

const getDayRange = () => {
  let mon = 0;
  let tue = 0;
  let wed = 0;
  let thu = 0;
  let fri = 0;
  let sat = 0;
  let sun = 0;
  if ($("#reslimit_mon").is(":checked")) {
    mon = 1;
  }
  if ($("#reslimit_tue").is(":checked")) {
    tue = 1;
  }
  if ($("#reslimit_wed").is(":checked")) {
    wed = 1;
  }
  if ($("#reslimit_thu").is(":checked")) {
    thu = 1;
  }
  if ($("#reslimit_fri").is(":checked")) {
    fri = 1;
  }
  if ($("#reslimit_sat").is(":checked")) {
    sat = 1;
  }
  if ($("#reslimit_sun").is(":checked")) {
    sun = 1;
  }
  return {
    mon,
    tue,
    wed,
    thu,
    fri,
    sat,
    sun,
  };
};

/** Init
 */
const init = (kd) => {
  // build limit selector

  const limits = Object.assign([], kd.find("limit", { active: 1 }, "order"));
  const location = kd.doc("location")[0];

  if (!limitID) {
    limitName = limits[0].name;
    limitID = limits[0]._id;
    limitData = Object.assign([], limits[0]);
  } else {
    // console.log('data existed', limitData);
    // limitData = Object.assign([], kd.doc("limit", limitID)[0]);
  }

  $("#layout_reslimit_limit_select").off();
  $("#layout_reslimit_limit_select").fastClick((e) => {
    const options = {
      target_id: e.target.id,
      type: "dropdown",
      position: "bottom",
      highlight: null,
      adjust: {
        x: -30,
        y: 0,
      },
    };

    const configdrop = [];

    limits.forEach((limit) => {
      configdrop.push({
        description: limit.name,
        value: limit._id,
      });
    });

    component.create(options, configdrop, (err, value) => {
      limitName = value.description;
      limitID = value.value;
      limitData = Object.assign([], kd.doc("limit", limitID)[0]);
      init(kd);
    });
  });

  $("#layout_reslimit_limit_select").html(`${limitName} \
        <i class="fa fa-angle-down fa-lg" aria-hidden="true"></i>`);

  $("#reslimit_type_select").off();
  $("#reslimit_type_select").fastClick((e) => {
    const options = {
      target_id: e.target.id,
      type: "dropdown",
      position: "bottom",
      highlight: null,
      adjust: {
        x: 0,
        y: -3,
      },
    };

    const selectdrop = [
      {
        description: l.translate("Limit By Date Range"),
        value: "date",
      },
      {
        description: l.translate("Limit By Days of Week"),
        value: "day",
      },
    ];

    component.create(options, selectdrop, (err, value) => {
      $("#reslimit_type_select").html(`${value.description} \
                <i class="fa fa-angle-down fa-lg" aria-hidden="true"></i>`);
      limitData.type = value.value;
      if (
        limitData.type == "date" &&
        !limitData.range.hasOwnProperty("start")
      ) {
        limitData.range = {
          start: moment().startOf("day").format("X"),
          end: moment().startOf("day").format("X"),
        };
      }
      init(kd);
    });
  });

  setType(limitData.type);

  if (limitData.type == "date") {
    $("#reslimit_start").off();
    $("#reslimit_start").fastClick((e) => {
      const options = {
        target_id: e.target.id,
        type: "calendar",
        allowPast: true,
        position: "right",
        startDate: limitData.range.start * 1000,
        adjust: {
          x: -30,
          y: 0,
        },
      };

      component.create(options, {}, (err, value) => {
        limitData.range.start = parseInt(
          moment(value.date).startOf("day").format("X"),
          10
        );
        init(kd);
      });
    });

    $("#reslimit_start").html(`${l.tcal(
      moment(limitData.range.start * 1000).format(
        l.translate("dddd, MMMM Do YYYY")
      )
    )} \
            <i class="fa fa-angle-down fa-lg" aria-hidden="true"></i>`);

    $("#reslimit_end").off();
    $("#reslimit_end").fastClick((e) => {
      const options = {
        target_id: e.target.id,
        type: "calendar",
        allowPast: true,
        position: "right",
        startDate: limitData.range.end * 1000,
        adjust: {
          x: -30,
          y: 0,
        },
      };

      component.create(options, {}, (err, value) => {
        limitData.range.end = parseInt(
          moment(value.date).endOf("day").format("X"),
          10
        );
        init(kd);
      });
    });

    $("#reslimit_end").html(`${l.tcal(
      moment(limitData.range.end * 1000).format(
        l.translate("dddd, MMMM Do YYYY")
      )
    )} \
            <i class="fa fa-angle-down fa-lg" aria-hidden="true"></i>`);
  } else if (limitData.type == "day") {
    // populate day checkboxes
    $("#reslimit_mon").prop("checked", false);
    $("#reslimit_mon").prop("checked", false);
    $("#reslimit_tue").prop("checked", false);
    $("#reslimit_wed").prop("checked", false);
    $("#reslimit_thu").prop("checked", false);
    $("#reslimit_fri").prop("checked", false);
    $("#reslimit_sat").prop("checked", false);
    $("#reslimit_sun").prop("checked", false);
    if (limitData.range.mon) {
      $("#reslimit_mon").prop("checked", true);
    }
    if (limitData.range.tue) {
      $("#reslimit_tue").prop("checked", true);
    }
    if (limitData.range.wed) {
      $("#reslimit_wed").prop("checked", true);
    }
    if (limitData.range.thu) {
      $("#reslimit_thu").prop("checked", true);
    }
    if (limitData.range.fri) {
      $("#reslimit_fri").prop("checked", true);
    }
    if (limitData.range.sat) {
      $("#reslimit_sat").prop("checked", true);
    }
    if (limitData.range.sun) {
      $("#reslimit_sun").prop("checked", true);
    }
  }

  $("#reslimit_open").off();
  $("#reslimit_open").fastClick((e) => {
    const options = {
      target_id: e.target.id,
      location,
      type: "time",
      position: "right",
      start: limitData.open,
      adjust: {
        x: 0,
        y: 17,
      },
    };

    component.create(options, {}, (err, value) => {
      limitData.range = getDayRange();
      limitData.open = value.index;
      init(kd);
    });
  });

  $("#reslimit_open").html(`${indexToTime(limitData.open, location.time24)} \
        <i class="fa fa-angle-down fa-lg" aria-hidden="true"></i>`);

  $("#reslimit_close").off();
  $("#reslimit_close").fastClick((e) => {
    const options = {
      target_id: e.target.id,
      location,
      type: "time",
      position: "right",
      start: limitData.close,
      adjust: {
        x: 0,
        y: 17,
      },
    };

    component.create(options, {}, (err, value) => {
      limitData.range = getDayRange();
      limitData.close = value.index;
      init(kd);
    });
  });

  $("#reslimit_close").html(`${indexToTime(limitData.close, location.time24)} \
        <i class="fa fa-angle-down fa-lg" aria-hidden="true"></i>`);

  // setup reslimit component

  reslimit.create("layout_reslimit_main", limitData, location, (err, data) => {
    limitData = data;
    save(kd, data);
  });

  $("#layout_reslimit_add").fastClick((event) => {
    const opt = {
      width: "80%",
      type: "dialog",
      h1: l.translate("Create New Reservation Limit Rule Set"),
      body: l.translate(
        "Please enter the name of the new reservation limit rule set."
      ),
      fields: [
        {
          description: l.translate("Limit Rule Set Name"),
        },
      ],
      buttons: [
        {
          description: l.translate("Cancel"),
          value: "cancel",
        },
        {
          description: l.translate("Add Set"),
          value: "addSheet",
        },
      ],
    };

    const data = {
      kd,
    };
    modal.create(opt, data, (err, value) => {
      if (value.button != "cancel" && value.fields[0]) {
        let pass = true;
        for (let i = 0; i < limits.length; ++i) {
          if (value.fields[0] === limits[i].name) {
            pass = false;
          }
        }
        if (pass) {
          modal.destroy();
          const now = new Date();
          const startOfDay = new Date(
            now.getFullYear(),
            now.getMonth(),
            now.getDate()
          );
          const timestamp = Math.round(startOfDay.getTime() / 1000);

          kd.update({
            domain: "limit",
            name: value.fields[0],
            open: 60,
            close: 88,
            seats: getSeatCount(kd),
            active: 1,
            order: 1,
            type: "date",
            range: {
              start: timestamp,
              end: timestamp,
            },
            limits: [
              {
                active: false,
                maxWeb: 8,
                turnTime: 60,
                start: 60,
                end: 67,
                size: 100,
                split: 60,
              },
              {
                active: false,
                maxWeb: 8,
                turnTime: 60,
                start: 67,
                end: 80,
                size: 100,
                split: 40,
              },
              {
                active: false,
                maxWeb: 8,
                turnTime: 60,
                start: 67,
                end: 80,
                size: 100,
                split: 90,
              },
            ],
          });
          setTimeout(() => {
            $("#layout_reslimit_limit_select").click();
            setTimeout(() => {
              $(".dropdownitem").first().click();
            }, 1);
          }, 500);
          const opt2 = {
            position: "top",
            width: "90%",
            seconds: 5,
            h1: l.translate("Limit Ruleset Added"),
            body: "",
            buttons: [
              {
                description: l.translate("ok"),
                value: "close",
              },
            ],
          };
          notification.create(opt2, {}, (err2, value2) => {
            notification.destroy();
          });

          init(kd);
        } else {
          const opt5 = {
            position: "top",
            width: "90%",
            seconds: 3,
            h1: l.translate("Reservation Limit name already exists"),
            body: l.translate(
              "Please choose a unique name for this Reservation " + "Limit."
            ),
            buttons: [
              {
                description: "ok",
                value: "close",
              },
            ],
          };
          notification.create(opt5, {}, (err2, value2) => {
            notification.destroy();
          });
        }
      } else {
        modal.destroy();
      }
    });
  });

  $("#layout_reslimit_edit").fastClick((event) => {
    const opt = {
      width: "90%",
      type: "dialog",
      h1: l.translate("Edit Limit Sheet"),
      body: l.translate(
        "Please enter a new name for this Reservation Limit Rule Set. " +
          "You can alternatively delete this set altogether."
      ),
      fields: [
        {
          description: limitName,
        },
      ],
      buttons: [
        {
          description: l.translate("Cancel"),
          value: "cancel",
        },
        {
          description: l.translate("Delete Set"),
          value: "deleteSheet",
        },
        {
          description: l.translate("Rename Set"),
          value: "renameSheet",
        },
      ],
    };

    const data = {
      kd,
    };
    modal.create(opt, data, (err, value) => {
      switch (value.button) {
        case "renameSheet":
          if (value.fields[0].length) {
            let pass = true;
            for (let i = 0; i < limits.length; ++i) {
              if (value.fields[0] === limits[i].name) {
                pass = false;
              }
            }
            if (pass) {
              modal.destroy();
              limitName = value.fields[0];
              kd.update({
                _id: limitID,
                domain: "limit",
                name: value.fields[0],
              })
                .then((result) => {
                  init(kd);
                })
                .catch((err3) => {
                  console.log("err3", err3);
                });
            } else {
              const opt5 = {
                position: "top",
                width: "90%",
                seconds: 3,
                h1: l.translate("Reservation Limit name already exists"),
                body: l.translate(
                  "Please choose a unique name for this " + "Reservation Limit."
                ),
                buttons: [
                  {
                    description: "ok",
                    value: "close",
                  },
                ],
              };
              notification.create(opt5, {}, (err2, value2) => {
                notification.destroy();
              });
            }
          } else {
            modal.destroy();
          }
          break;
        case "deleteSheet":
          modal.destroy();
          kd.update({
            _id: limitID,
            domain: "limit",
            active: 2,
          })
            .then((result) => {
              limitID = null;
              init(kd);
            })
            .catch((err4) => {
              console.log("err4", err4);
            });
          break;
        case "cancel": {
          modal.destroy();
          break;
        }
        default:
          break;
      }
    });
  });
};

const save = (kd, data) => {
  switch (data.type) {
    case "day": {
      limitData.range = getDayRange();
      break;
    }
    case "date": {
      data.range = {
        start: parseInt(limitData.range.start, 10),
        end: parseInt(limitData.range.end, 10),
      };
      break;
    }
    default:
      break;
  }

  limitData = Object.assign({}, data);
  limitData.seats = getSeatCount(kd);

  // compare day and date sheets to existing sheets
  if (compareSheet(kd, limitData)) {
    if (kd.mode === "guestlist") {
      delete limitData._kd;
      limitData._kd = {};
      limitData._kd.mergerule = "REPLACE";
      kd.update(limitData)
        .then((result) => {
          const opt = {
            position: "top",
            width: "90%",
            seconds: 3,
            h1: "Reservation Limits Saved. ",
            body: "",
            buttons: [
              {
                description: "ok",
                value: "close",
              },
            ],
          };
          notification.create(opt, {}, (err, value) => {
            notification.destroy();
          });
        })
        .catch((err) => {
          console.log("err", err);
        });
      const location_data = Object.assign({}, kd.doc("location")[0]);
      const chart_data = Object.assign(
        {},
        kd.doc("chart", location_data.chart)[0]
      );
      const limit_data = Object.assign([], kd.doc("limit"));
      for (let i = 0; i < limit_data.length; ++i) {
        if (limit_data[i].name === limitData.name) {
          limit_data[i] = limitData;
        }
        limit_data[i]._kd.site_id = "embed";
      }
      const template_data = Object.assign(
        [],
        kd.find("template", {
          $and: [{ active: 1 }, { chart: location_data.chart }],
        })
      );

      const postData = {
        gla: {
          location: location_data,
          chart: chart_data,
          limit: limit_data,
          template: template_data,
        },
      };

      const payload = {
        messageSource: "GL",
        action: "UPDATE",
        payload: postData,
      };
      window.parent.postMessage(payload, "*");
    } else if (kd.mode == "xenial") {
      const location_data = Object.assign({}, kd.doc("location")[0]);
      const chart_data = Object.assign(
        {},
        kd.doc("chart", location_data.chart)[0]
      );
      const limit_data = Object.assign([], kd.doc("limit"));
      for (let i = 0; i < limit_data.length; ++i) {
        if (limit_data[i].name === limitData.name) {
          limit_data[i] = limitData;
        }
        limit_data[i]._kd.site_id = "embed";
      }
      const template_data = Object.assign(
        [],
        kd.find("template", {
          $and: [{ active: 1 }, { chart: location_data.chart }],
        })
      );

      delete location_data.meta;
      delete location_data.$loki;

      delete chart_data._kd.created;
      delete chart_data._kd.updated;
      delete chart_data._kd.confirmed;
      delete chart_data.meta;
      delete chart_data.$loki;

      for (let i = 0; i < template_data.length; ++i) {
        delete template_data[i].meta;
        delete template_data[i].$loki;
        delete template_data[i]._kd.updated;
        template_data[i]._kd.site_id = "embed";
      }

      for (let i = 0; i < limit_data.length; ++i) {
        delete limit_data[i].meta;
        delete limit_data[i].$loki;
        delete limit_data[i]._kd.confirmed;
        delete limit_data[i]._kd.updated;
        limit_data[i]._kd.site_id = "embed";
      }

      const headers = {
        Accept: "application/json",
        "Content-Type": "application/json",
        "X-Company-Id": kd.xenial.companyID,
        Authorization: `Bearer ${kd.xenial.accessToken}`,
      };
      const postData = [
        {
          _id: kd.xenial.config._id,
          name: kd.xenial.config.name,
          gla: {
            location: location_data,
            chart: chart_data,
            limit: limit_data,
            template: template_data,
          },
          entity_id: kd.xenial.config.entity_id,
        },
      ];

      const payload = {
        messageSource: "GL",
        action: "UPDATE",
        payload: postData,
      };
      window.parent.postMessage(payload, "*");

      $.ajax({
        url: `${kd.xenial.dmEnvironmentURL}/floor-plan/entity/\
${kd.xenial.config.entity_id}`,
        type: "POST",
        contentType: "application/json",
        headers,
        data: JSON.stringify(postData),
        success: (result) => {
          console.log("save success");
        },
        error: (jqXHR, textStatus, errorThrown) => {
          console.log(textStatus);
        },
        timeout: 10000,
      });
    }
  } else {
    const opt2 = {
      position: "top",
      width: "90%",
      seconds: 10,
      h1: l.translate("Can not save"),
      body: l.translate(
        "The current working sheet can not save because it overlaps with a " +
          "previously existing sheet. Different sheets can not cover the same day of week or " +
          "date range."
      ),
      buttons: [
        {
          description: l.translate("ok"),
          value: "close",
        },
      ],
    };
    notification.create(opt2, {}, (err2, value2) => {
      notification.destroy();
    });
  }
};

const compareSheet = (kd, limit) => {
  const limits = kd.find("limit", { active: 1 });
  for (let i = 0; i < limits.length; ++i) {
    if (limit._id !== limits[i]._id) {
      if (limit.type === "day" && limits[i].type === "day") {
        if (limit.range.mon === 1 && limits[i].range.mon === 1) {
          return false;
        }
        if (limit.range.tue === 1 && limits[i].range.tue === 1) {
          return false;
        }
        if (limit.range.wed === 1 && limits[i].range.wed === 1) {
          return false;
        }
        if (limit.range.thu === 1 && limits[i].range.thu === 1) {
          return false;
        }
        if (limit.range.fri === 1 && limits[i].range.fri === 1) {
          return false;
        }
        if (limit.range.sat === 1 && limits[i].range.sat === 1) {
          return false;
        }
        if (limit.range.sun === 1 && limits[i].range.sun === 1) {
          return false;
        }
      } else if (limit.type === "date" && limits[i].type === "date") {
        if (
          (limit.range.start < limits[i].range.start &&
            limit.range.end < limits[i].range.start) ||
          (limit.range.start > limits[i].range.end &&
            limit.range.end > limits[i].range.end)
        ) {
          return true;
        }
        return false;
      }
    }
  }
  return true;
};

const getSeatCount = (kd) => {
  const chartID = kd.doc("location")[0].chart;
  const tablesdata = kd.doc("chart", chartID)[0].tables;
  let seatCount = 0;
  for (let t = 0; t < tablesdata.length; ++t) {
    if (tablesdata[t].type !== "icon" && tablesdata[t].seats > 1) {
      seatCount += tablesdata[t].seats;
    }
  }
  return seatCount;
};

const setType = (type) => {
  switch (type) {
    case "date":
      $("#reslimit_type_select").html(`${l.translate("Limit By Date Range")} \
            <i class="fa fa-angle-down fa-lg" aria-hidden="true"></i>`);
      $("#reslimit_range_date").css("display", "block");
      $("#reslimit_range_day").css("display", "none");
      break;
    case "day":
      $("#reslimit_type_select").html(`${l.translate("Limit By Days of Week")} \
            <i class="fa fa-angle-down fa-lg" 'aria-hidden="true"></i>`);
      $("#reslimit_range_date").css("display", "none");
      $("#reslimit_range_day").css("display", "block");
      break;
    default:
      break;
  }
};

const indexToTime = (index, time24) => {
  let timeFormat = l.translate("h:mm a");
  if (time24) {
    timeFormat = "H:mm";
  }
  const minute = `0${(index % 4) * 15}`.slice(-2);
  return moment(`${Math.floor(index / 4)}:${minute}`, "HH:mm").format(
    timeFormat
  );
};

module.exports = {
  init,
  reslimit,
};



/** WEBPACK FOOTER **
 ** ./src/controllers/reslimit/index.js
 **/